import type { BlueprintSnapshot } from '../core/blueprint.ts';

export function blueprintDataCutoff(snapshot: BlueprintSnapshot): string | null {
  const cutoff = snapshot.data_cutoffs.nflverse_regular_seasons?.trim();
  if (cutoff) return cutoff;
  const seasons = snapshot.training_seasons.filter(Number.isInteger);
  return seasons.length > 0 ? String(Math.max(...seasons)) : null;
}

export function formatBlueprintFreshness(snapshot: BlueprintSnapshot, locale?: string): string {
  const cutoff = blueprintDataCutoff(snapshot);
  const freshness = formatTimestamp(snapshot.generated_at, locale);
  return `data through ${cutoff ?? 'an unknown season'} · refreshed ${freshness}`;
}

export function blueprintMetadataTitle(snapshot: BlueprintSnapshot): string {
  const generated = validDate(snapshot.generated_at) ? new Date(snapshot.generated_at).toISOString() : 'unknown';
  const expires = validDate(snapshot.expires_at) ? new Date(snapshot.expires_at).toISOString() : 'unknown';
  return `Model ${snapshot.model_version}; generated ${generated}; expires ${expires}; source ${snapshot.source}.`;
}

function formatTimestamp(value: string, locale?: string): string {
  const date = validDate(value) ? new Date(value) : null;
  if (!date) return 'refresh time unavailable';
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(date);
}

function validDate(value: string): boolean {
  return Number.isFinite(Date.parse(value));
}
